module.exports = __webpack_public_path__ + "img/landingphoto.ced3ff57.jpg";